import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Config } from "../.env";

const ModuleSelection = () => {
  const location = useLocation();

  const token = location.state?.token || localStorage.getItem("authToken");
  if (token && !localStorage.getItem("authToken")) {
    localStorage.setItem("authToken", token);
  }
  const brandEmail =
    location.state?.brandEmail || localStorage.getItem("Brand Email") || "";

  const [creatorMarketing, setCreatorMarketing] = useState(false);
  const [communityMarketing, setCommunityMarketing] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    if (!creatorMarketing && !communityMarketing) {
      toast.error("Please select at least one option.");
      return;
    }

    const isCommunityOnlySelection = communityMarketing && !creatorMarketing;

    if (isCommunityOnlySelection) {
      localStorage.setItem(
        "pendingBrandModules",
        JSON.stringify({
          creatorMarketing,
          communityMarketing,
        })
      );
      localStorage.setItem(
        "brandModules",
        JSON.stringify(["communityMarketing"])
      );

      toast.success("Continue with your community brand name.");
      window.location.href = `${Config.SITE_URL}/community/brand/add-brand-details${
        brandEmail ? `?brandEmail=${encodeURIComponent(brandEmail)}` : ""
      }`;
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${Config.API_URL}/select-modules`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          creatorMarketing,
          communityMarketing,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || data.error || "Unable to save modules");
      }

      if (data.profiles?.influencerUser) {
        localStorage.setItem(
          "brandCreatorUser",
          JSON.stringify(data.profiles.influencerUser)
        );
        localStorage.setItem(
          "brandUser",
          JSON.stringify(data.profiles.influencerUser)
        );
      }

      localStorage.setItem("brandModules", JSON.stringify(data.modules));
      localStorage.setItem("userRole", "brand");

      toast.success("Modules selected successfully");
      window.location.href = `${Config.SITE_URL}/creators/brand/register`;
    } catch (error) {
      console.error("Brand module selection error:", error);
      toast.error(error.message || "Failed to save selected modules");
    } finally {
      setLoading(false);
    }
  };

  const optionCardStyle = (selected) => ({
    flex: "1 1 320px",
    minHeight: "220px",
    padding: "24px",
    borderRadius: "20px",
    border: selected ? "2px solid #111827" : "1px solid rgba(17, 24, 39, 0.14)",
    background: selected ? "rgba(17, 24, 39, 0.05)" : "#ffffff",
    boxShadow: selected
      ? "0 18px 45px rgba(17, 24, 39, 0.12)"
      : "0 12px 32px rgba(15, 23, 42, 0.08)",
    cursor: "pointer",
    transition:
      "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 20px",
        background:
          "radial-gradient(circle at top, rgba(255, 255, 255, 0.92), rgba(243, 244, 246, 0.96) 45%, rgba(229, 231, 235, 1) 100%)",
      }}
    >
      <div style={{ width: "100%", maxWidth: "1100px", textAlign: "center" }}>
        <h1
          style={{
            margin: 0,
            fontSize: "clamp(2rem, 4vw, 3.25rem)",
            fontWeight: 800,
            color: "#111827",
            letterSpacing: "-0.03em",
          }}
        >
          How do you want to grow your brand?
        </h1>

        <div
          style={{
            marginTop: "36px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          <label
            style={optionCardStyle(creatorMarketing)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <input
                type="checkbox"
                checked={creatorMarketing}
                onChange={(e) => setCreatorMarketing(e.target.checked)}
                style={{
                  width: "20px",
                  height: "20px",
                  accentColor: "#111827",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 700,
                  color: "#111827",
                  textAlign: "left",
                }}
              >
                Work with Creators
              </span>
            </div>

            <p
              style={{
                margin: 0,
                fontSize: "0.98rem",
                lineHeight: 1.7,
                color: "#4b5563",
                textAlign: "left",
              }}
            >
              UGC, influencers, paid partnerships, barter collaborations,
              product reviews, social media content, creator visits
            </p>
          </label>

          <label
            style={optionCardStyle(communityMarketing)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <input
                type="checkbox"
                checked={communityMarketing}
                onChange={(e) => setCommunityMarketing(e.target.checked)}
                style={{
                  width: "20px",
                  height: "20px",
                  accentColor: "#111827",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 700,
                  color: "#111827",
                  textAlign: "left",
                }}
              >
                Grow Your Reputation (through communities)
              </span>
            </div>

            <p
              style={{
                margin: 0,
                fontSize: "0.98rem",
                lineHeight: 1.7,
                color: "#4b5563",
                textAlign: "left",
              }}
            >
              Ratings, reviews, Google Business, marketplaces, app stores,
              community discussions, bulk posting campaigns
            </p>
          </label>
        </div>

        <div
          style={{
            marginTop: "34px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            onClick={handleContinue}
            disabled={loading}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "14px 28px",
              minWidth: "180px",
              background: loading ? "#9ca3af" : "#111827",
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 14px 30px rgba(17, 24, 39, 0.18)",
              transition: "transform 180ms ease, box-shadow 180ms ease",
            }}
            onMouseEnter={(e) => {
              if (!loading)
                e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            {loading ? "Saving..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModuleSelection;
